import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useFlag, useHubspotChat } from '@sketch/modules-common'

// Constants
import { SKETCH_WEBSITE } from '@sketch/env-config'

// Components
import {
  Dropdown,
  TableComponents,
  SelectDropdownButtonItem,
  SelectDropdownExternalLinkItem,
} from '@sketch/components'

// Local Icons
import { icons } from '../../icons'

// Styles
import { DropdownDivider, DropdownItem } from './OldHelpMenu.styles'

interface HelpMenuProps {
  title?: string
}

const HelpMenu: React.FC<HelpMenuProps> = ({ title = 'Help with Sketch' }) => {
  const hasHubspotChatSupportOn = useFlag('hubspot-chat-support')

  const { loadChat } = useHubspotChat()
  const { search } = useLocation()

  // only try to load the chat on the first load (avoids eternal loops)
  useEffect(() => {
    // check if chatWithUs is on the URl to auto load hubspot chat
    const URLparams = new URLSearchParams(search)
    const isChatWithUsLaunch = URLparams.get('chatWithUs')

    if (isChatWithUsLaunch === 'true') {
      loadChat()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Dropdown
        toggle={<SelectDropdownButtonItem icon={icons.LifeBelt} text={title} />}
        placement="top"
        contentPadding="8px"
      >
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.Home}
            href={`${SKETCH_WEBSITE}/home`}
            text="sketch.com"
          />
        </DropdownItem>
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.SketchLogo}
            href={`${SKETCH_WEBSITE}/downloads/mac`}
            text="Download the Mac App"
          />
        </DropdownItem>

        <DropdownDivider />

        {/* This is used here since style-wise is the same component */}
        <DropdownItem>
          <TableComponents.TableHeaderCell as="div">
            Get Help
          </TableComponents.TableHeaderCell>
        </DropdownItem>

        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.Notebook}
            href={`${SKETCH_WEBSITE}/docs/`}
            text="Documentation"
          />
        </DropdownItem>
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.QuestionMark}
            href={`${SKETCH_WEBSITE}/support/general/`}
            text="Frequently Asked Questions"
          />
        </DropdownItem>
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.Command}
            href={`${SKETCH_WEBSITE}/docs/designing/shortcuts/#web-app-shortcuts`}
            text="Keyboard Shortcuts"
          />
        </DropdownItem>
        {hasHubspotChatSupportOn && (
          <SelectDropdownButtonItem
            icon={icons.ChatIcon}
            onClick={loadChat}
            text="Chat with Us"
          />
        )}
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.MailEnvelope}
            href={`${SKETCH_WEBSITE}/support/contact/`}
            text="Contact Us"
          />
        </DropdownItem>
        <DropdownItem>
          <SelectDropdownExternalLinkItem
            icon={icons.ChatBubbles}
            href="https://forum.sketch.com"
            text="Community Forum"
          />
        </DropdownItem>
      </Dropdown>
    </>
  )
}

export default HelpMenu
